import { render, staticRenderFns } from "./ViqSourceCard.vue?vue&type=template&id=00aad6e6&scoped=true"
import script from "./ViqSourceCard.vue?vue&type=script&lang=js"
export * from "./ViqSourceCard.vue?vue&type=script&lang=js"
import style0 from "./ViqSourceCard.vue?vue&type=style&index=0&id=00aad6e6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aad6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00aad6e6')) {
      api.createRecord('00aad6e6', component.options)
    } else {
      api.reload('00aad6e6', component.options)
    }
    module.hot.accept("./ViqSourceCard.vue?vue&type=template&id=00aad6e6&scoped=true", function () {
      api.rerender('00aad6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqSourceCard.vue"
export default component.exports